<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
  import NewsLetterService from 'src/services/NewsLetterService'

  export default {
    name: 'news-letter-details',
    methods: {
      async getNewsletter () {
        const {id} = this.$route.params
        let res = await NewsLetterService.getById(id, {
          with: 'user,segments'
        })
        this.$store.commit('newsletter/SET_CURRENT_NEWS_LETTER', res.data)
      }
    },
    watch: {
      '$store.state.config.textLanguage' () {
        this.getNewsletter()
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id
        let res = await NewsLetterService.getById(id, {
          with: 'user,segments'
        })
        let data = res.data
        if (data) {
          next(vm => {
            vm.$store.commit('newsletter/SET_CURRENT_NEWS_LETTER', data)
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    }

  }
</script>
<style>
</style>
